export default function CTASection() {
  return (
    <section className="relative w-full bg-background-50 py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950 leading-tight mb-4">
          USFansSpreadsheet 2026 – Gotowy na najlepsze rozwiązanie?
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-8 md:mb-10 max-w-xl mx-auto">
          Sprawdź pełne możliwości na naszej głównej stronie.
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-medium hover:bg-primary-600 transition-colors"
        >
          Kup teraz na kaspreadsheet.com
          <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
        </a>
      </div>

      <div className="max-w-5xl mx-auto mt-12 md:mt-16">
        <div className="flex justify-center gap-4 md:gap-6 flex-wrap">
          {[
            "https://readdy.ai/api/search-image?query=Clean%20white%20sneaker%20styled%20on%20warm%20terracotta%20ceramic%20surface%20with%20dry%20pampas%20grass%2C%20soft%20golden%20hour%20side%20light%2C%20lifestyle%20product%20photography%2C%20modern%20minimalist%20aesthetic%2C%20no%20text%20no%20branding%2C%20elegant%20natural%20composition&width=300&height=300&seq=cta-prod-v2-01&orientation=squarish",
            "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20handbag%20on%20smooth%20river%20stone%20with%20soft%20moss%20detail%2C%20dappled%20forest%20light%2C%20organic%20luxury%20product%20photography%2C%20sage%20green%20natural%20palette%2C%20no%20text%20no%20branding%2C%20serene%20nature%20inspired%20composition&width=300&height=300&seq=cta-prod-v2-02&orientation=squarish",
            "https://readdy.ai/api/search-image?query=Modern%20fashion%20accessories%20arranged%20on%20cream%20linen%20fabric%20with%20dried%20flowers%2C%20soft%20morning%20window%20light%2C%20editorial%20still%20life%20photography%2C%20warm%20neutral%20tones%2C%20no%20text%20no%20branding%2C%20romantic%20minimalist%20aesthetic&width=300&height=300&seq=cta-prod-v2-03&orientation=squarish",
            "https://readdy.ai/api/search-image?query=Premium%20baseball%20cap%20on%20weathered%20wooden%20surface%20at%20golden%20hour%20outdoor%20setting%2C%20warm%20dappled%20sunlight%2C%20lifestyle%20product%20photography%2C%20rich%20amber%20and%20cream%20tones%2C%20no%20text%20no%20branding%2C%20Mediterranean%20summer%20atmosphere&width=300&height=300&seq=cta-prod-v2-04&orientation=squarish",
          ].map((src, idx) => (
            <div key={idx} className="w-20 h-20 md:w-24 md:h-24 rounded-2xl overflow-hidden bg-secondary-100">
              <img
                src={src}
                alt=""
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}